import styled from 'styled-components';
import { staticURL } from 'core/url';

import { BlockSize } from 'libs/rendering/gltf/config';

export const Canvas3DStyled = styled.canvas`
  background: black; /* needed for proper WebGL tranparency */
  width: ${props => (props.width ? props.width : '100%')};
  display: ${props => (props.hidden ? 'none' : 'block')};
  pointer-events: auto;
  height: 100%;
  display: block;
  outline: none;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  image-rendering: pixelated;
  cursor: ${props => (props.mousePointing ? 'pointer' : 'default')};
  &:active {
    cursor: grabbing;
  }
  ${props =>
    props.isInAnnotationMode &&
    `
    cursor: url(${staticURL('/assets/cursors/annotation.svg')}) 0 16, auto;
  `}
  ${props =>
    props.isInAnnotationMode &&
    props.mousePointing &&
    `
    cursor: url(${staticURL(
      '/assets/cursors/annotation-add.svg',
    )}) 0 16, pointer;
  `}
`;

const legendRowHeight = 22;
const legendTitleHeight = 25;

export const LegendWrapper = styled.nav`
  height: ${9 * legendRowHeight + legendTitleHeight - 0.5 * legendRowHeight}px;
  bottom: ${legendRowHeight + 8}px;
  right: ${props => props.right}px;
  margin: ${props => props.theme.spacing.xsmall};
  padding: ${props => props.theme.spacing.default};
  position: absolute;
  background: ${props => props.theme.color.wfBlack};
  border: 1px solid ${props => props.theme.color.wfWhite};
  border-radius: 5px;
  color: ${props => props.theme.color.wfWhite};
  font-size: 0.8rem;
  display: ${props => (props.visible ? 'block' : 'none')};
`;

export const UnitsWrapper = styled.nav`
  height: ${legendTitleHeight}px;
  width: 100%;
  position: absolute;
  top: -2px;
  left: 0;
  font-size: 0.85rem;
  text-align: center;
`;

export const GradientWrapper = styled.nav`
  top: ${legendTitleHeight - 3}px;
  width: ${BlockSize.circle};
  height: ${8 * legendRowHeight + 2}px;
  right: ${props => props.theme.spacing.xsmall};
  border: 1px solid ${props => props.theme.color.wfWhite};
  position: absolute;
`;

export const Gradient = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    #ff0000,
    #ffff00 25%,
    #00ff00 50%,
    #00ffff 75%,
    #0000ff
  );
`;

export const BinaryGradient = styled.div`
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, #ff0000, #0000ff);
`;

export const NodeStyled = styled.div`
  display: flex;
  flex-direction: column;
  height: ${9 * legendRowHeight}px;
  position: aboslute;
  right: ${BlockSize.circle};
  margin-top: ${legendTitleHeight - 0.5 * legendRowHeight - 5}px;
`;

export const RowWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  height: ${legendRowHeight}px;
  bottom: ${0.5 * legendRowHeight}px;
  padding-right: 6px;
  right: ${0.5 * legendRowHeight - 6}px;

  &::after {
    content: '';
    display: block;
    width: 0;
    height: 0;
    position: absolute;
    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;
    border-right: 4px solid ${props => props.theme.color.wfWhite};
    right: 2px;
    top: ${0.5 * legendRowHeight - 3}px;
`;
